export class Country {
    constructor(
        public id?: number,
        public name?: string,
        public abbrev?: string,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/country/country.model.ts